module.exports = __webpack_public_path__ + "img/slash-forward.10701b7e.svg";